import authFetch from "components/Authentication/AuthFetch"
const api_url = process.env.REACT_APP_OIDC_AUTH_URL;

export const getRecentDisciplines = () => {
  return authFetch(`${api_url}/api/profile/recent_disciplines`)
    .then(res => res.json() )
}



// WEBPACK FOOTER //
// ./src/api/profile/recentDisciplines.js